<template>
  <div>
    <span style="width: 100%;">{{ lable }}</span>
  </div>
</template>

<script>
    export default {
      name: "BasicInfoDetail",
      props: {
        flag :{
          default: "1",
        },
        codeValue: {
          default: "",
        },
        codeArray: {
          type: Array,
        }
      },

      computed: {
        lable: function () {
          if (this.flag == "1"){
            return this.codeValue;
          }else {
            let label = "";
            if (this.codeArray){
              this.codeArray.forEach((arr) =>{
                if (arr.cd == this.codeValue){
                  label =  arr.cdDesc;
                }
              })
            }
            return label
          }
        }
      }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/member/BasicInfoDetail.vue